import { Button, Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { useState } from "react";
import DataTable from "../../components/features/Datatable";
import Filter from "./Filter";
// import { click } from "@testing-library/user-event/dist/cjs/convenience/click.js";
import { useNavigate } from "react-router-dom";



const QRGeneration = () => {
const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState(0);

  const updateFilter = () => {}


  const columns = [
    {
      id: 'patient_id',
      name: 'Subject/Patient ID',
      selector: row => row.patient_id,
      sortable: true
    },
    {
      id: 'name',
      name: 'Subject Name',
      selector: row => row.name,
      sortable: true
    },
    {
      id: 'product',
      name: 'Product/Phase',
      selector: row => `${row.product}/${row.phase}`,
      sortable: true
    },
    {
      id: 'type',
      name: 'Type',
      selector: row => row.type,
      sortable: true
    },
    {
      id: 'hospital',
      name: 'Hospital',
      selector: row => row.hospital,
      sortable: true
    },
    {
        id: 'date',
        name: 'Apheresis Date',
        selector: row => row.hospital,
        sortable: true
      },
    {
      id: 'status',
      name: 'Status',
      selector: row => <span style={{ color: row.status === 'QR Code Generated' ? '#00B278' : '#FF2023', fontWeight: '400', fontSize: '14px', fontFamily:'roboto' }}>
      {row.status}
    </span>,
      sortable: true
    },
    {
      name: 'Action',
      selector: row => <Button onClick={() => navigate(`/bmr/qr-generation/details`)} key={row.id} size="small" className="!w-[100px]">View Details</Button>,
    },
  ];

  const data = {
    items: [
      {
        "id": 1,
        "patient_id": "P03C132LUCMED01LYP001",
        "name": "Ramesh Rajput",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "Max Super Specialty",
        "date": "28/04/2014",
        "status": "QR Code Generated"
      },
      {
        "id": 2,
        "patient_id": "P03C132LUCMED01LYP002",
        "name": "Anita Sharma",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "Clinical Trial",
        "hospital": "Apollo Hospital",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 3,
        "patient_id": "P03C132LUCMED01LYP003",
        "name": "Rahul Verma",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "PMS",
        "hospital": "Fortis Hospital",
        "date": "28/04/2014",
        "status": "QR Code Generated"
      },
      {
        "id": 4,
        "patient_id": "P03C132LUCMED01LYP004",
        "name": "Pooja Malhotra",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "Clinical Trial",
        "hospital": "Medanta Hospital",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 5,
        "patient_id": "P03C132LUCMED01LYP005",
        "name": "Suresh Patil",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "PMS",
        "hospital": "AIIMS",
        "status": "Pending"
      },
      {
        "id": 6,
        "patient_id": "P03C132LUCMED01LYP006",
        "name": "Kavita Das",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "Clinical Trial",
        "hospital": "Manipal Hospital",
        "date": "28/04/2014",
        "status": "QR Code Generated"
      },
      {
        "id": 7,
        "patient_id": "P03C132LUCMED01LYP007",
        "name": "Manoj Kumar",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "CMC Vellore",
        "date": "28/04/2014",
        "status": "QR Code Generated"
      },
      {
        "id": 8,
        "patient_id": "P03C132LUCMED01LYP008",
        "name": "Jyoti Mehta",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "Clinical Trial",
        "hospital": "Narayana Health",
        "date": "28/04/2014",
        "status": "QR Code Generated"
      },
      {
        "id": 9,
        "patient_id": "P03C132LUCMED01LYP009",
        "name": "Amit Bhardwaj",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "PMS",
        "hospital": "Tata Memorial Hospital",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 10,
        "patient_id": "P03C132LUCMED01LYP010",
        "name": "Sunita Yadav",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "Clinical Trial",
        "hospital": "Kokilaben Hospital",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 11,
        "patient_id": "P03C132LUCMED01LYP011",
        "name": "Vikram Singh",
        "product": "CAR-T",
        "phase": "Phase 1",
        "type": "PMS",
        "hospital": "Jaypee Hospital",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 12,
        "patient_id": "P03C132LUCMED01LYP012",
        "name": "Neha Choudhary",
        "product": "Gene Therapy",
        "phase": "Phase 3",
        "type": "Clinical Trial",
        "hospital": "Sankara Nethralaya",
        "date": "28/04/2014",
        "status": "Pending"
      },
      {
        "id": 13,
        "patient_id": "P03C132LUCMED01LYP013",
        "name": "Arun Nair",
        "product": "BCMA",
        "phase": "Phase 2",
        "type": "PMS",
        "hospital": "Global Hospitals",
        "date": "28/04/2014",
        "status": "Pending"
      }
    ]
  };

  return (
    <Grid container className='m-4 ml-0 mainDiv' rowSpacing={4.5} columnSpacing={2.75}>
      {/* <Grid item xs={12} sx={{ mb: -2.25 }}>
        <Typography variant="h5">QRGeneration</Typography>
      </Grid> */}
      {[].map((item, index) => (
        <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
          <Card>
            <CardActionArea
              onClick={() => setSelectedCard(index)}
              data-active={selectedCard === index ? '' : undefined}
              sx={{
                height: '100%',
                '&[data-active]': {
                  backgroundColor: 'action.selected',
                  '&:hover': {
                    backgroundColor: 'action.selectedHover',
                  },
                },
              }}
            >
              <CardContent sx={{ height: '100%' }}>
                <Typography variant="h5" component="div">
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
      <Grid item xs={12} sx={{ mt: -2.25 }}>
        <DataTable
          columns={columns}
          data={data}
          title="Subject"
          FilterComponent={Filter}
          // isServerSide={true}
          onServerSideChange={updateFilter}
        />
      </Grid>
    </Grid>
  );
};

export default QRGeneration;
